import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("servall_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

export const formatPrice = (n) => {
    if (n == null || isNaN(n)) return "—";
    if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
    if (n >= 1000) return `₹${(n / 1000).toFixed(0)}k`;
    return `₹${n}`;
};

export const formatPriceRange = (min, max) => {
    if (min === max) return formatPrice(min);
    return `${formatPrice(min)} – ${formatPrice(max)}`;
};

export const ytEmbed = (url) => {
    if (!url) return "";
    const m = url.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
    if (!m || m[1] === "dQw4w9WgXcQ") return "";
    return `https://www.youtube.com/embed/${m[1]}`;
};

// Resolve uploaded file paths (returned as /api/uploads/...) to full absolute URLs
export const resolveAsset = (url) => {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
};

// Upload an image to the backend (brand logos, hero carousel, etc.)
export const uploadFile = async (file) => {
    const form = new FormData();
    form.append("file", file);
    const { data } = await api.post("/admin/upload-image", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};
